import { FilesResponseType, TreeItemType } from '@api';
import {
  useCreateFolderModalMethods,
  UseCreateFolderModalMethodsReturnType,
  useTreeMethods,
  useUploadFileModalMethods,
  UseUploadFileModalMethodsReturnType,
} from '@common';
import { TreeInstance } from '@headless-tree/core';

type TreeMethodsType = {
  rootFolderId: string;
  tree: TreeInstance<TreeItemType>;
  isFetching: boolean;
  onDeleteItem: (item: TreeItemType) => void;
  onCreateFolder: (parentId: string) => void;
  onAddFile: (parentId: string) => void;
};

type UseFileTreeMethodsReturnType = {
  treeMethods: TreeMethodsType;
  createFolderModalMethods: UseCreateFolderModalMethodsReturnType;
  uploadFileModalMethods: UseUploadFileModalMethodsReturnType;
};

type UseFileTreeMethodsPropsType = {
  locationId: string;
  files: FilesResponseType;
  isInitiallyExpanded: boolean;
  isFetchingTreeItems: boolean;
  refetchFiles: () => void;
};

export const useFileTreeMethods = ({
  files,
  locationId,
  isInitiallyExpanded,
  isFetchingTreeItems,
  refetchFiles,
}: UseFileTreeMethodsPropsType): UseFileTreeMethodsReturnType => {
  const createFolderModalMethods = useCreateFolderModalMethods({
    locationId,
    refetchFiles,
  });

  const uploadFileModalMethods = useUploadFileModalMethods({
    locationId,
    refetchFiles,
  });

  const tree = useTreeMethods({
    files,
    isFetchingTreeItems,
    refetchFiles,
    isInitiallyExpanded,
  });

  return {
    treeMethods: {
      ...tree,
      onCreateFolder: createFolderModalMethods.openModal,
      onAddFile: uploadFileModalMethods.openModal,
    },
    createFolderModalMethods,
    uploadFileModalMethods,
  };
};
